import { useEffect, useState } from "react";
import MembershipInfo from "../../components/membership/MembershipInfo";
import { useFieldArray, useForm } from "react-hook-form";
import BookingPrivilege from "../../components/membership/BookingPrivilege";
import MembershipConfigurations from "../../components/membership/MembershipConfigurations";
import { useDispatch, useSelector } from "react-redux";
import { UserSliceType } from "../../lib/redux/slices/userSlice";
import AddSvg from "../../assets/icons/addDark.svg";
import {
  useCreateMembershipMutation,
  useEditMembershipMutation,
  useGetMembershipByIdQuery,
} from "../../lib/redux/services/sections/Customers";
import { useGetAllCourtsQuery } from "../../lib/redux/services/sections/Courts";
import MembershipBenefit from "../../components/membership/MembershipBenefit";
import Button from "../../components/global/Button";
import { toast } from "react-toastify";
import { hasOverlappingHoursWithInfo, toastMessage } from "../../utils/utils";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../components/skeletons/Loader";
import { MembershipRequest } from "../../types/request/membership";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";
import { setFormIsDirty } from "../../lib/redux/slices/formSlice";
import ErrorSection from "../../components/global/ErrorSection";
import useBlocker from "../../hooks/useBlocker";
import { Check } from "lucide-react";
import { daysOptions } from "../../data/options";

type Props = {
  data?: any;
};

type props = {
  type: "edit" | "view";
};
function MembershipInfoTwo({ type = "edit" }: props) {
  const { shared, options }: DictionaryType = useGetDictionary();
  const selectedClub = useSelector((state: any) => state.user.selectedClub);
  const defaultLine = {
    allowed_court_ids: [],
    allowed_service_ids: [],
    time_range_type: "custom",
    selects_days: [],
    from_time: "",
    to_time: "",
    discount_type: "percentage",
    application: "member_share",
  };
  useBlocker();
  const [overlappingRows, setOverlappingRows] = useState<any[]>([]);
  const {
    control,
    handleSubmit,
    watch,
    reset,
    formState: { errors, isDirty },
    setValue,
    trigger,
    getValues,
  } = useForm<MembershipRequest>({
    disabled: type === "view",
    defaultValues: {
      benefits: [defaultLine],
    },
  });
  const {
    fields: benifit,
    append: benifitAppend,
    remove: benifitRemove,
  } = useFieldArray({ control, name: "benefits" });
  const dispatch = useDispatch();
  useEffect(() => {
    if (isDirty) dispatch(setFormIsDirty(true));
    else dispatch(setFormIsDirty(false));
  }, [isDirty]);
  const param = useParams();
  const navigate = useNavigate();
  const [editMembership] = useEditMembershipMutation();
  // fetch membership data when id is available
  const {
    data: membershipData,
    isLoading: loadingMembership,
    isFetching,
    isSuccess,
    isError,
  } = useGetMembershipByIdQuery(param.id, {
    skip: !param.id,
  });
  // get all courts in club
  const clubId = useSelector((state: UserSliceType) => state.user.selectedClub);
  const [selectedGroups, setSelectedGroups] = useState(new Set());

  const { data, isLoading } = useGetAllCourtsQuery({ club_id: clubId });
  // create membership mutation
  const [createMembership] = useCreateMembershipMutation();
  // map courts to label and value
  const courts = data?.data?.map((court: { name: string; id: number }) => {
    return { label: court.name, value: court.id };
  });
  // submit membership form
  const onSubmit = async (data: MembershipRequest) => {
    const { status, ...requestData } = JSON.parse(
      JSON.stringify(membershipData?.data)
    );
    console.log(data.benefits);

    const OverLappInfo = hasOverlappingHoursWithInfo(data.benefits);
    if (OverLappInfo.ovelappFound) {
      const currentDay = daysOptions(options).find((day) => {
        return day.value === parseInt(OverLappInfo.day!);
      })?.label;

      setOverlappingRows([
        OverLappInfo?.firstRowIndex,
        OverLappInfo.secondRowIndex,
      ]);

      toast.error(
        `there is overlapping found between Benefit${
          //@ts-ignore
          OverLappInfo.firstRowIndex + 1
          //@ts-ignore
        } and Benefit${OverLappInfo.secondRowIndex + 1} on day ${currentDay}`
      );
      return;
    }
    try {
      // create final data object with club_ids, court_ids and service_ids
      const finalData = {
        ...requestData,
        ...data,
        club_ids: data?.club_ids?.map((club: any) => parseInt(club.id)),
        court_ids: data?.court_ids?.map((court: any) => parseInt(court.id)),
        service_ids: data?.service_ids?.map((service: any) =>
          parseInt(service.id)
        ),
      };
      // if id is available, edit membership
      if (param.id && type === "edit") {
        await toast.promise(
          editMembership({
            data: finalData,
            owner_club_id: selectedClub,
            id: param.id,
          })
            .unwrap()
            .then((res) => {
              navigate('/club-settings/customer?currentPage=1&currentSize=10&sectionType=memberships')
              console.log(res?.data?.data?.id);
            }),
          toastMessage()
        );
        // if id is not available, create membership
      } else {
        await toast.promise(
          createMembership({
            data: finalData,
            owner_club_id: selectedClub,
          }).unwrap().then((res)=>{
            navigate('/club-settings/customer?currentPage=1&currentSize=10&sectionType=memberships')
          }),
          toastMessage()
        );
      }
      // navigate to membership page with section=membership
    } catch (error) {}
  };
  // reset form when membership data is fetched
  useEffect(() => {
    if (isSuccess && membershipData) {
      if (membershipData.data?.benefits?.length > 0) {
        reset({
          ...membershipData.data,
        });
      } else {
        reset({
          ...membershipData.data,
          benefits: [defaultLine],
        });
      }
    }
  }, [membershipData, isSuccess]);
  // show loader when fetching membership data
  if (isFetching || loadingMembership) {
    return (
      <div className="w-full min-h-dvh justify-center items-center flex">
        <Loader />
      </div>
    );
  }
  // show error message when membership data is not fetched
  //   if (isError) {
  //     return <ErrorSection/>;
  //   }
  return (
    <>
      <div className="flex w-full items-center justify-center gap-4">
        <div className="p-[10px] rounded-full border bg-primary">
          <span className="w-5 h-5  grid place-content-center">
            <Check color="#CBDB2A" />
          </span>
        </div>
        <div className="w-[155px] h-[3px] bg-[#ccc]"></div>
        <div className="p-[10px] rounded-full border border-primary">
          <span className="w-5 h-5 bg-primary rounded-full block"></span>
        </div>
      </div>
      <div className="flex w-full items-center justify-center gap-4">
        <div className="p-[10px] text-primary">Step 1</div>
        <div className="w-[130px] "></div>
        <div className="p-[10px]  text-primary text-center">Step 2</div>
      </div>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="p-2 w-full flex flex-col gap-12 max-h-[calc(100dvh-250px)] overflow-y-auto customScroll text-start "
      >
        <BookingPrivilege
          control={control}
          eventType={type}
          errors={errors}
          getValues={getValues}
        />
        {benifit.map((_, index: number) => (
          <MembershipBenefit
            key={index}
            control={control}
            errors={errors}
            getValues={getValues}
            index={index}
            watch={watch}
            eventType={type}
            setSelectedGroups={setSelectedGroups}
            selectedGroups={selectedGroups}
            setValue={setValue}
            overlappingRows={overlappingRows}
            setOverlappingRows={setOverlappingRows}
          />
        ))}

        <div className="flex flex-row justify-end w-full">
          <img
            loading="lazy"
            className=" pt-8 w-10 text-right cursor-pointer"
            onClick={() => benifitAppend(defaultLine)}
            src={AddSvg}
            alt="add"
          />
        </div>
        <div className="flex pt-2 gap-3 justify-end w-full items-center pr-4 pb-4">
          <Button
            customeStyle=" text-red-500 hover:border hover:border-red-500 p-3 px-2 rounded-full w-[200px] mobile:w-[120px]"
            text={type === "view" ? shared.close : shared.cancel}
            width="150px"
            type="submit"
            onClick={(e) => {
              e.preventDefault();
              navigate("/club-settings/customer?section=membership");
            }}
          />
          <Button
            customeStyle=" text-primary border border-primary p-3 px-2 rounded-full w-[200px] mobile:w-[120px]"
            text={shared.back}
            width="150px"
            type="button"
            onClick={(e) => {
              e.preventDefault();
              navigate(
                type === "view"
                  ? `/club-settings/membership/view/${param.id}`
                  : `/club-settings/membership/edit/${param.id}`
              );
            }}
          />
          {type !== "view" && (
            <Button
              customeStyle="bg-primary text-white dark:bg-primaryYellow dark:text-primary p-3 px-2 rounded-full w-[200px] mobile:w-[120px]"
              text={"Publish"}
              width="150px"
              type="submit"
            />
          )}
        </div>
      </form>
    </>
  );
}

export default MembershipInfoTwo;
